import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import nextI18nextConfig from 'next-i18next.config'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'
import SeoHead from '@/components/seo/SeoHead'
import { siteUrl, articleSchema } from 'lib/seoConfigs'

export default function PageArtikelMehrwertEinerGutenDatenueberwachungsschnittstelle() {
  const { t } = useTranslation('article0003')

  const router = useRouter()
  const currentLocale = Array.isArray(router.query.locale)
    ? router.query.locale[0]
    : router.query.locale || nextI18nextConfig.i18n.defaultLocale

  return (
    <>
      <SeoHead
        title={t('title')}
        description={t('description')}
        dePath="artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle"
        enPath="articles/added-value-of-a-good-data-monitoring-interface"
        ogType="article"
        schema={articleSchema({
          headline: t('title'),
          description: t('description'),
          url: `${siteUrl}/${currentLocale === 'de' ? 'artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle' : 'articles/added-value-of-a-good-data-monitoring-interface'}/`
        })}
      />

      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="A0003" isArticle />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'articles', 'article0003'])
export { getStaticPaths, getStaticProps }
